<script>
  import { getContext, onMount } from 'svelte';
  import TabRegistrationType from './TabRegistrationType.svelte';
  import { Modal } from 'bootstrap';

  export let comeFrom = '';
  export let clientType = [];
  export let registrationType = [];
  export let projectTypes = [];
  export let clientTypes = [];
  export let registrationTypes = [];
  let fundProfiles = [];
  let selectedTasks = [];
  let formLoading = false;
  let filter = false;
  import { client } from 'root/api/index.js';
  import { searchKeyByValue, cloneArray } from 'components/Helper.js';
  const getClientDetail = () => {
    if (extraFilter.unitId > 0) {
      formLoading = true;
      if (extraFilter.clientId > 0) {
        client.getClientMasterData({ id: extraFilter.clientId }).then((result) => {
          let unitMasterData = result.data;
          clientTypes = unitMasterData.clientTypes;
          projectTypes = unitMasterData.projectTypes;
          registrationTypes = unitMasterData.registrationTypes;
          // fundProfiles=unitMasterData.fundProfiles;

          extraFilter = {
            ...extraFilter,
            clientTypes: clientTypes,
            registrationTypes: registrationTypes,
            projectTypes: projectTypes,
          };
          filter = false;
          formLoading = false;
        });
      } else {
        extraFilter = {
          ...extraFilter,
        };
        filter = false;
        formLoading = false;
      }
    }
  };
  const setFilter = (params) => {
    extraFilter = { ...params };
  };
  let filterModal;
  export let showSubFilter = (params) => {
    setFilter(params);
  };
  export let extraFilter = {};
  onMount(() => {
    filterModal = new Modal(document.getElementById('filterModal'), {
      keyboard: false,
    });
    if (comeFrom == 'client') {
      extraFilter.taskSubType = 1;
      clientTypes = clientType;
      registrationTypes = registrationType;
    } else {
      if (comeFrom == 'assignTask') {
      } else {
        getClientDetail();
      }
    }
  });
  export const hide = () => {
    if (filterModal != undefined) {
      filterModal.hide();
    }
  };
  export let applyFilter = () => {};
  let openType = '';
  export let show = (type) => {
    openType = type;
    filterModal.show();
  };
  const getCount = (arr, sub) => {
    var count = 0;
    try {
      for (var i in arr) {
        count += arr[i][sub].length;
        count++;
      }
    } catch (e) {}
    return count;
  };
  const showDialog = getContext('showDialog');
</script>

{#if extraFilter.taskSubType == 1 || extraFilter.taskSubType == 3}
  <button
    class="btn shadow-none btn-reg-filter font-size-13 dropdown-toggle border-0"
    on:click={() => {
      show('clientType');
    }}
  >
    Client Type <span class="select-dropdown-counter"
      >{extraFilter.clientTypes && getCount(extraFilter.clientTypes, 'subClientTypes') > 0
        ? getCount(extraFilter.clientTypes, 'subClientTypes')
        : ''}</span
    >
    {#if getCount(extraFilter.clientTypes, 'subClientTypes') > 0}
      <button
        class="remove-btn bg-transparent border-0"
        on:click={(e) => {
          extraFilter.clientTypes = [];
          applyFilter(extraFilter, 'clientType');
          e.stopImmediatePropagation();
          openType = '';
        }}
      >
        <img
          alt=""
          src="/images/close.svg"
        />
      </button>
    {/if}
  </button>
  <button
    class="btn shadow-none btn-reg-filter font-size-13 dropdown-toggle border-0"
    on:click={() => {
      show('registerType');
    }}
  >
    Registration Type <span class="select-dropdown-counter"
      >{extraFilter.registrationTypes &&
      getCount(extraFilter.registrationTypes, 'subRegistrationTypes') > 0
        ? getCount(extraFilter.registrationTypes, 'subRegistrationTypes')
        : ''}</span
    >
    {#if getCount(extraFilter.registrationTypes, 'subRegistrationTypes') > 0}
      <button
        class="remove-btn bg-transparent border-0"
        on:click={(e) => {
          extraFilter.registrationTypes = [];
          applyFilter(extraFilter, 'registrationType');
          e.stopImmediatePropagation();
          openType = '';
        }}
      >
        <img
          alt=""
          src="/images/close.svg"
        />
      </button>
    {/if}
  </button>
{/if}
{#if extraFilter.taskSubType == 2 || extraFilter.taskSubType == 3}
  <button
    class="btn shadow-none btn-reg-filter font-size-13 dropdown-toggle border-0"
    on:click={() => {
      show('project');
    }}
  >
    Project <span class="select-dropdown-counter"
      >{extraFilter.projectTypes && extraFilter.projectTypes.length > 0
        ? extraFilter.projectTypes.length
        : ''}</span
    >
    {#if extraFilter.projectTypes && extraFilter.projectTypes.length > 0}
      <button
        class="remove-btn bg-transparent border-0"
        on:click={(e) => {
          extraFilter.projectTypes = [];
          applyFilter(extraFilter, 'project');
          e.stopImmediatePropagation();
          openType = '';
        }}
      >
        <img
          alt=""
          src="/images/close.svg"
        />
      </button>
    {/if}
  </button>
{/if}
<div
  class="modal fade slide-modal show"
  id="filterModal"
  tabindex="-1"
  aria-labelledby="userProfileModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog w-100 add-task-modal h-100 m-0 float-end">
    <div class="modal-content">
      {#if formLoading}
        loadingData...
      {:else}
        <div class="d-flex flex-column h-100">
          <div class="modal-header rounded-0 d-flex flex-column">
            <div class="d-flex flex-row justify-content-between w-100">
              <h5 class="mb-0 font-size-13 color-black">
                {#if openType == 'clientType'}
                  Client Type
                {:else if openType == 'registerType'}
                  Registration Type
                {:else if openType == 'project'}
                  Project
                {/if} Filter
              </h5>
              <button
                type="button"
                class="close btn-close"
                on:click={() => hide()}
              ></button>
            </div>
          </div>

          <div class="page-content">
            <div
              class="nav flex-column assign-task-left h-100"
              id="v-pills-tab"
              role="tablist"
              aria-orientation="vertical"
            >
              <div class="page-content">
                <div class="d-flex flex-column h-100">
                  <div
                    class="tab-content page-content"
                    id="myTabContent"
                  >
                    {#if openType == 'clientType'}
                      <div
                        class="tab-pane fade show active"
                        id="profile"
                        role="tabpanel"
                        aria-labelledby="profile-tab"
                      >
                        <div class="task-details p-3">
                          <ul class="ps-0">
                            <TabRegistrationType
                              comeFrom={comeFrom}
                              itemData={clientTypes}
                              selectedItem={extraFilter.clientTypes}
                              childKey="subClientTypes"
                              on:onSelect={(event) => {
                                extraFilter.clientTypes = event.detail;
                              }}
                            />
                          </ul>
                        </div>
                      </div>
                    {:else if openType == 'registerType'}
                      <div
                        class="tab-pane fade show active"
                        id="home"
                        role="tabpanel"
                        aria-labelledby="home-tab"
                      >
                        <div class="task-details p-3">
                          <ul class="ps-0">
                            <TabRegistrationType
                              comeFrom={comeFrom}
                              itemData={registrationTypes}
                              selectedItem={extraFilter.registrationTypes}
                              childKey="subRegistrationTypes"
                              on:onSelect={(event) => {
                                extraFilter.registrationTypes = event.detail;
                              }}
                            />
                          </ul>
                        </div>
                      </div>
                    {:else if openType == 'project'}
                      <div
                        class="tab-pane fade show active"
                        id="project"
                        role="tabpanel"
                        aria-labelledby="profile-tab"
                      >
                        <div class="task-details p-3">
                          <ul>
                            <TabRegistrationType
                              comeFrom={comeFrom}
                              itemData={projectTypes}
                              selectedItem={extraFilter.projectTypes}
                              on:onSelect={(event) => {
                                extraFilter.projectTypes = event.detail;
                              }}
                            />
                          </ul>
                        </div>
                      </div>
                    {/if}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer rounded-0">
            <div class="d-flex flex-row justify-content-between w-100 align-items-center">
              <div>
                <button
                  on:click={() => {
                    let isError = false;
                    if (openType == 'clientType' && extraFilter.clientTypes.length == 0) {
                      // extraFilter.clientTypes=cloneArray(clientTypes)
                      isError = true;
                    } else if (
                      openType == 'registerType' &&
                      extraFilter.registrationTypes.length == 0
                    ) {
                      // extraFilter.registrationTypes=cloneArray(registrationTypes)
                      isError = true;
                    } else if (openType == 'project' && extraFilter.projectTypes.length == 0) {
                      // extraFilter.projectTypes=cloneArray(projectTypes)
                      isError = true;
                    }
                    if (isError) {
                      showDialog({
                        title: '',
                        message: 'Select at least one option to apply filter',
                      });
                    } else {
                      hide();
                      applyFilter(extraFilter, openType);
                    }
                  }}
                  type="button"
                  color="primary"
                  class="btn btn-primary shadow-none background-blue mb-0 text-white add-task px-4 font-size-12"
                >
                  <span class="color-white font-size-12 font-weight-400">Apply Filter</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      {/if}
    </div>
  </div>
</div>
